module.exports = __webpack_public_path__ + "img/safety.26db311b.png";